import React from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { at } from 'lodash';
import { useField } from 'formik';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import PropTypes from 'prop-types';
import InputField from './InputField';

function RadioField(props) {
  const { label, data, other, otherName, ...rest } = props;
  const [field, meta, helper] = useField(props);
  const { value: selectedValue } = field;
  const [touched, error] = at(meta, 'touched', 'error');
  const isError = touched && error && true;
  const { setValue } = helper;
  const [enableText, setEnableText] = React.useState(true);

  function _renderHelperText() {
    if (isError) {
      return <FormHelperText>{error}</FormHelperText>;
    }
  }

  function handleChange(event) {
    setValue(event.target.value);
    if (event.target.value === 'outro') setEnableText(false);
    else setEnableText(true);
  }

  return (
    <FormControl component="fieldset" {...rest} error={isError}>
      <FormLabel component="legend">{label}</FormLabel>
      <RadioGroup
        aria-label=""
        value={selectedValue || ''}
        onChange={handleChange}
      >
        {data.map((item, index) => (
          <FormControlLabel
            key={index}
            value={item.value}
            control={<Radio />}
            label={item.label}
          />
        ))}
        {other ? (
          <div>
            <FormControlLabel
              value="outro"
              control={<Radio />}
              label="Outro:"
            />
            <InputField
              disabled={enableText}
              name={otherName}
              fullWidth
              margin="normal"
            />
          </div>
        ) : null}
      </RadioGroup>
      {_renderHelperText()}
    </FormControl>
  );
}

RadioField.defaultProps = {
  data: [],
};

RadioField.propTypes = {
  data: PropTypes.array.isRequired,
};

export default RadioField;
